(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire0d69"];
var parcelRegister = parcelRequire.register;
parcelRegister("c65X8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ceaa9aae9201645$export$2e2bcd8739ae039; });
var $8ceaa9aae9201645$var$contributionModal = function() {
    var contributorBtns = document.querySelectorAll("button.js-open-contributors");
    var contributorModals = document.querySelectorAll("aside.contributors-modal");
    var html = document.querySelectorAll("html")[0];
    if (contributorBtns && contributorModals) {
        contributorBtns.forEach(function(elm) {
            elm.addEventListener("click", function(e) {
                var modal = Array.from(contributorModals).find(function(element) {
                    return element.dataset.contributors === elm.dataset.contributors;
                });
                if (!modal) return;
                modal.classList.remove("hidden");
                html.classList.add("js-scroll-hidden");
            });
        });
        contributorModals.forEach(function(elm) {
            elm.addEventListener("click", function(e) {
                if (e.target.classList.contains("contributors-modal") || e.target.classList.contains("close-menu-btn")) {
                    elm.classList.add("hidden");
                    html.classList.remove("js-scroll-hidden");
                }
            });
        });
    }
};
var $8ceaa9aae9201645$export$2e2bcd8739ae039 = $8ceaa9aae9201645$var$contributionModal;

});

})();
//# sourceMappingURL=contributors-modal.fa885994.js.map
